declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

const MEASUREMENT_ID = "G-YGRPPSTRXL";

export function initializeGA() {

    if (document.getElementById("ga-script")) {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
        window.dataLayer.push(arguments);
    };

    const script = document.createElement("script");

    script.id = "ga-script";

    script.async = true;

    script.src =
        `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;

    document.head.appendChild(script);

    script.onload = () => {

        console.log("GA Script Loaded");

        window.gtag("js", new Date());

        window.gtag("config", MEASUREMENT_ID);

    };

}